import Image from 'next/image'

import Box from 'components/atomic/atoms/box'
import Text from 'components/atomic/atoms/text'
import LayoutWebsite from 'components/pages/@layouts/layout-website'
import Divider from 'components/pages/@shared/divider'

const investors = [
  {
    image: '/images/investors/ameet.png',
    name: 'Ameet Patel',
    role: 'Investor'
  },
  {
    image: '/images/investors/ben.png',
    name: 'Ben Braverman',
    role: 'Chief Business Officer',
    company: 'Hadrian'
  },

  {
    image: '/images/investors/charlie.png',
    name: 'Charlie Songhurst',
    role: 'Investor'
  },

  {
    image: '/images/investors/christian.png',
    name: 'Christian Wiklund',
    role: 'Founder & CEO UnitQ',
    company: 'UnitQ'
  },
  {
    image: '/images/investors/christopher.png',
    name: 'Christopher Federico',
    role: 'Head of Global Cloud Security Sales',
    company: 'Check Point Software'
  },
  {
    image: '/images/investors/dane.png',
    name: 'Dane Knecht',
    role: 'SVP Emerging Technology and Incubation',
    company: 'Cloudflare'
  },

  {
    image: '/images/investors/dani.png',
    name: 'Dani Undurraga',
    role: 'Co-founder & CTO',
    company: 'Cornershop by Uber'
  },
  {
    image: '/images/investors/david.png',
    name: 'David Mytton',
    role: 'Co-Founder & CEO',
    company: 'Console.dev'
  },

  {
    image: '/images/investors/dennis.png',
    name: 'Dennis Mårtensson',
    role: 'Director of Engineering Edge State',
    company: 'Fastly'
  },
  {
    image: '/images/investors/devaris.png',
    name: 'DeVaris Brown',
    role: 'Founder & CEO',
    company: 'Meroxa'
  },
  {
    image: '/images/investors/guillermo.png',
    name: 'Guillermo Rauch',
    role: 'Founder & CEO',
    company: 'Vercel'
  },
  {
    image: '/images/investors/jason.png',
    name: 'Jason Hunt',
    role: 'VP Ecosystem'
  },
  {
    image: '/images/investors/jeff.png',
    name: 'Jeff Silverstein',
    role: 'Investment Partner',
    company: 'Andreessen Horowitz'
  },
  {
    image: '/images/investors/jennifer.png',
    name: 'Jennifer Campbell',
    role: 'Founder & CEO Tagomi',
    company: 'Tagomi'
  },
  {
    image: '/images/investors/leore.png',
    name: 'Leore Avidar',
    role: 'Founder & CEO',
    company: 'Lob'
  },
  {
    image: '/images/investors/liu.png',
    name: 'Liu Jiang',
    role: 'Ex-Partner',
    company: 'Sequoia'
  },
  {
    image: '/images/investors/luke.png',
    name: 'Luke Byrne',
    role: 'General Partner',
    company: 'Pebblebed'
  },

  {
    image: '/images/investors/marc.png',
    name: 'Marc Bhargava',
    role: 'Founder & President',
    company: 'Tagomi'
  },

  {
    image: '/images/investors/marc-dioune.png',
    name: 'Marc Diouane',
    role: 'COO & President',
    company: 'Pindrop'
  },

  {
    image: '/images/investors/marcus.png',
    name: 'Marcus Gruneau',
    role: 'Senior Solutions Engineer',
    company: 'Cogniac Corporation'
  },

  {
    image: '/images/investors/mathias.png',
    name: 'Mathias Christiensen',
    role: 'Founder & CEO',
    company: 'Netlify'
  },

  {
    image: '/images/investors/michael.png',
    name: 'Michael Ma',
    role: 'Founder',
    company: 'CreatorDAO'
  },

  {
    image: '/images/investors/nat.png',
    name: 'Nat Friedman',
    role: 'Ex-CEO',
    company: 'GitHub'
  },

  {
    image: '/images/investors/nico.png',
    name: 'Nico Chinot',
    role: 'Founding Investor',
    company: 'Persona'
  },

  {
    image: '/images/investors/niklas.png',
    name: 'Niklas Lindstrom',
    role: 'Founder & CTO',
    company: 'unitQ'
  },

  {
    image: '/images/investors/oliver.png',
    name: 'Olivier Pomel',
    role: 'Founder & CEO',
    company: 'Datadog'
  },

  {
    image: '/images/investors/oskar.png',
    name: 'Oskar Hjertonsson',
    role: 'Founder & CEO',
    company: 'Cornershop by Uber'
  },
  {
    image: '/images/investors/romain.png',
    name: 'Romain Huet',
    role: 'Engineer & Entrepreneur',
    company: 'Ex-Stripe'
  },

  {
    image: '/images/investors/sabrina.png',
    name: 'Sabrina Hahn',
    role: 'Venture Investor'
  },

  {
    image: '/images/investors/sean.png',
    name: 'Sean Li',
    role: 'Founder & CEO',
    company: 'Magic'
  },
  {
    image: '/images/investors/spencer.png',
    name: 'Spencer Kimball',
    role: 'Founder & CEO',
    company: 'Cockroach Labs'
  },

  {
    image: '/images/investors/surabhi.png',
    name: 'Surabhi Gupta',
    role: 'Head of Engineering',
    company: 'Robinhood'
  },

  {
    image: '/images/investors/thomas.png',
    name: 'Thomas Paul Mann',
    role: 'Founder & CEO',
    company: 'Raycast'
  },
  {
    image: '/images/investors/thor.png',
    name: 'Thor Philogene',
    role: 'Founder & CEO',
    company: 'Stravito'
  },
  {
    image: '/images/investors/vincenzo.png',
    name: 'Vincenzo Iozzo',
    role: 'CEO',
    company: 'SlashID'
  },
  {
    image: '/images/investors/william.png',
    name: 'William Smith',
    role: 'Investor',
    company: 'Octave'
  },
  {
    image: '/images/investors/zach.png',
    name: 'Zach Lloyd',
    role: 'Founder & CEO',
    company: 'Warp'
  },
  {
    image: '/images/investors/zack.png',
    name: 'Zack Kanter',
    role: 'Founder & CEO',
    company: 'Stedi'
  }
]

const Investor = ({
  image,
  name,
  role,
  company
}: {
  image: string
  name: string
  role: string
  company?: string
}) => {
  return (
    <Box
      flex="column"
      items="center"
      justify="center"
      textCenter
      css={{
        flexBasis: '40%',
        '@sm': {
          flexBasis: '25%'
        },
        '@md': {
          flexBasis: '15%'
        }
      }}
    >
      <Box relative flex items="center" justify="center" css={{ size: 100 }}>
        <Image
          alt={name}
          src={image}
          fill
          style={{ borderRadius: '50%', objectFit: 'cover' }}
        />
      </Box>
      <Text as="p" size="sm" weight="medium" css={{ mt: '$5' }}>
        {name}
      </Text>
      <Text as="p" color="text2" size="sm">
        {role}
      </Text>
      {!!company && (
        <Text as="p" color="text2" size="sm">
          {company}
        </Text>
      )}
    </Box>
  )
}

const AboutPage = () => {
  return (
    <LayoutWebsite
      meta={{ title: 'About', imageUrl: '/images/og/community.png' }}
    >
      <Box
        css={{
          backgroundImage: 'url("/images/bg/about-bg.png")',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center'
        }}
      >
        <Box
          flex
          items="center"
          justify="center"
          as="section"
          css={{
            container: 'xl',
            pb: 65,
            '@md': { pt: '$14' }
          }}
        >
          <Box textCenter css={{ '@md': { container: 'md' } }}>
            <Text
              as="h1"
              weight="bold"
              css={{
                fontSize: 48,
                lineHeight: 0.9,
                letterSpacing: '$tighter',
                '@lg': {
                  fontSize: 72,
                  lineHeight: 1
                }
              }}
            >
              We democratize access to data
            </Text>
            <Text
              as="p"
              color="text2"
              size={{ '@initial': 'md', '@md': 'lg' }}
              css={{ mt: '$6' }}
            >
              Grafbase enables developers to build high performance applications
              faster.
              <br />
              Focus on shipping products instead of building complex
              infrastructure.
            </Text>
          </Box>
        </Box>
      </Box>

      <Box as="section" css={{ container: 'xl', py: '$32' }}>
        <Box textCenter>
          <Text
            as="h2"
            size={{ '@initial': '2xl', '@md': '4xl' }}
            weight="bold"
          >
            Investors
          </Text>
        </Box>
        <Box css={{ mt: '$20' }}>
          <Box
            flex
            items="center"
            justify="center"
            css={{
              container: 'md'
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 810 48"
              width="100%"
              fill="none"
            >
              <path
                fill="currentColor"
                d="M27.156 14.373a20.889 20.889 0 0 1-.271-2.083 224.82 224.82 0 0 0-2.335-1.097 7.9 7.9 0 0 0 .295 5.106c.684 1.686.472 5.131-.471 8.507a13.933 13.933 0 0 1-2.111 4.068c.306.434.684.958 1.132 1.557a20.623 20.623 0 0 0 3.36-6.639c.982-3.045 1.12-6.3.401-9.418m12.204 3.953-2.382-1.149a48.454 48.454 0 0 1-2.157 1.988c-1.981 2.816-2.547 3.026-2.217 1.25a36.598 36.598 0 0 0 1.38-4.693 406.91 406.91 0 0 0-2.076-1.01 133.506 133.506 0 0 1-1.179 5.435c-.495 2.1.884 5.386-5.86 12.198.224.288.46.59.719.896.142.135.295.274.448.412a328.494 328.494 0 0 0 7.11-8.343c1.958-2.37 4.28-4.672 6.214-6.985m1.12 6.455c.991-1.714 1.899-3.266 2.654-4.654-.802-.38-1.64-.778-2.453-1.17a22.556 22.556 0 0 0-2.358 4.598c-.272.877-2.11 3.849-6.403 7.9-1.391 1.32-2.854 2.63-4.174 3.891.295.307.59.616.884.927a35.621 35.621 0 0 1 3.078-2.367c2.676-2.182 6.768-5.67 8.773-9.121m-35.87-1.97c-.024.045-.059.093-.082.142.393 1.376.553 2.809.471 4.238-.295 3.403.401 6.618 1.132 5.797a27.551 27.551 0 0 0 1.675-5.137c.153-1.702-1.274-5.377-1.663-8.945-.649 1.695-1.156 3.153-1.533 3.906Zm35.068 10.908.247-.277a53.415 53.415 0 0 0-9.15 5.223 74.5 74.5 0 0 1 1.392 1.666c.722-.582 1.51-1.08 2.346-1.482a14.747 14.747 0 0 0 2.382-1.61 43.15 43.15 0 0 1 2.783-3.52ZM3.066 27.697a5.542 5.542 0 0 0-.106-1.5A36.872 36.872 0 0 0 .32 31.941a18.114 18.114 0 0 0 1.038 3.67 10.2 10.2 0 0 1 .318 2.188c.235.337.487.661.755.972a3.42 3.42 0 0 0 2.24 1.278c.047-.488.07-1 .094-1.533.012-.251.036-.507.06-.763a31.97 31.97 0 0 0-1.144-4.537 10.277 10.277 0 0 1-.614-5.518m15.447-14.433c-.955 2.904-1.155 4.66-.884 9.183s-.613 6.076-1.84 7.358a9.694 9.694 0 0 0-1.792 2.637 39.378 39.378 0 0 1 4.634-2.565 32.93 32.93 0 0 0 2.193-11.009 16.312 16.312 0 0 1 .271-5.469c.309-1.129.553-2.274.732-3.43-1.097-.473-2.029-.848-2.772-1.098a12.628 12.628 0 0 1-.542 4.394M45.091 26.58c.908-1.44 1.05-3.235 1.757-4.735-.896-.4-1.132-.513-2.075-.943-2.029 3.184-4.682 7.602-4.941 9.26a33.878 33.878 0 0 0 5.259-3.575m-30.54-12.943c1.828-2.297 1.51-8 1.993-11.512a11.44 11.44 0 0 1 .413-1.816l-.036-.31a46.92 46.92 0 0 0-4.162 3.745l-.731-.97-.283.347-.189 4.155s1.156-1.34 1.91-2.114a.021.021 0 0 1 .012 0c2.724-2.5-1.368 3.646-3.066 7.697a13.124 13.124 0 0 0-.92 4.614c-.041.908-.002 1.818.119 2.72v.038c.188 1.35.504 2.68.943 3.971a7.602 7.602 0 0 1-.413 5.806 12.322 12.322 0 0 0-1.84 5.401 25.22 25.22 0 0 1-.14 3.092 13.636 13.636 0 0 0 1.898-2.3c.52-.753 1.12-1.448 1.792-2.07-.012-1.2-.2-3.007.872-4.192 1.227-1.35.909-4.968.779-7.665-.13-2.696-.779-6.323 1.05-8.638m23.134 33.444c.943-6.292 6.084-11.24 7.24-13.001 1.25-1.335 5.837-6.721 2.77-12.145-.129 1.922.449 5.471-3.265 9.51-7.287 6.978-8.42 13.595-8.42 13.595l1.51 2.948.165-.907ZM84.637 34.931a6.88 6.88 0 1 0-.047-13.76 6.88 6.88 0 0 0 .047 13.76Zm-.969-21.422c4.137 0 6.752 1.242 8.275 3.83v-2.858h7.72v27.136h-7.72v-2.913c-1.308 2.59-4.091 3.83-8.49 3.83-8.229 0-13.889-5.934-13.889-14.515 0-8.525 5.83-14.516 14.104-14.516m25.316-8.04h8.213v36.145h-8.213V5.463Zm13.935 9.014h8.489l5.276 16.941 5.275-16.943h8.506l-9.859 27.142h-7.89l-9.797-27.14Zm51.708 10.683a5.995 5.995 0 0 0-6.198-4.694 5.905 5.905 0 0 0-6.152 4.694h12.35Zm-6.26-11.601a14.307 14.307 0 0 1 13.485 9.171 14.295 14.295 0 0 1 .942 5.667 9.529 9.529 0 0 1-.215 2.215h-20.471a5.739 5.739 0 0 0 5.982 5.076 6.193 6.193 0 0 0 5.014-2.154l.385-.38h8.382c-2.553 5.882-7.521 9.382-13.396 9.382a14.49 14.49 0 0 1-13.46-19.982 14.49 14.49 0 0 1 13.352-8.994m21.948.923h7.721v2.86a8.21 8.21 0 0 1 7.521-3.778 10.613 10.613 0 0 1 7.398 2.753c2.061 1.942 2.722 4.048 2.722 8.367v16.932h-8.213v-14.78a6.612 6.612 0 0 0-.831-4 4.106 4.106 0 0 0-3.475-1.671 4.646 4.646 0 0 0-3.861 1.888 4.973 4.973 0 0 0-.769 3.4v15.164h-8.213V14.481v.002Z"
              />
              <path
                fill="currentColor"
                fillRule="evenodd"
                d="M402.857 25.081c.028-.656.15-1.266.37-1.827a4.615 4.615 0 0 1 .924-1.478 4.243 4.243 0 0 1 1.458-1.004c.574-.247 1.244-.37 2.011-.37 1.533 0 2.66.41 3.386 1.231.726.822 1.089 1.97 1.089 3.448h-9.238Zm4.885-8.99c-1.587 0-3.037.253-4.351.758a9.23 9.23 0 0 0-3.386 2.238c-.946.986-1.678 2.184-2.197 3.594-.521 1.409-.781 3.017-.781 4.823 0 3.612.897 6.404 2.69 8.375 1.793 1.97 4.468 2.956 8.025 2.956 2.956 0 5.207-.624 6.754-1.868 1.546-1.245 2.511-3.073 2.895-5.481h-5.584c-.41 1.916-1.751 2.875-4.023 2.875-1.642 0-2.874-.487-3.695-1.46-.822-.97-1.259-2.317-1.313-4.043h14.861V26.56c0-3.204-.828-5.747-2.483-7.638-1.657-1.887-4.127-2.831-7.412-2.831ZM439.151 16.748h-5.994l-4.106 6.115-3.653-6.115h-6.774l7.021 10.427-7.76 11.003h6.241l4.557-6.98 4.351 6.98h6.651l-7.472-11.33 6.938-10.1ZM450.779 33.395c-.465-.397-.698-1.156-.698-2.279v-9.894h4.927v-4.474h-4.927V9.81h-5.747v6.938h-3.367v4.474h3.367v10.017c0 2.655.568 4.544 1.703 5.665 1.136 1.123 2.881 1.684 5.235 1.684 2.731 0 4.065-.657 4.065-.657v-4.229s-1.369.288-2.75.288c-.74 0-1.342-.198-1.808-.595ZM469.915 27.215h-6.898l6.898-9.893v9.893Zm5.46-17.406h-5.255l-12.972 18.105v3.9h12.767v6.364h5.46v-6.364h3.304v-4.599h-3.304V9.81ZM479.878 9.81v4.967h13.506a134.1 134.1 0 0 0-5.029 11.166 161.751 161.751 0 0 0-4.29 12.235h6.363c1.177-4.38 2.539-8.512 4.085-12.4a110.002 110.002 0 0 1 5.399-11.535V9.81h-20.034ZM387.936 28.551 376.163 9.81h-5.797v28.369h5.952V19.6l11.81 18.578h5.762V9.809h-5.954v18.742ZM352.524 43.2h2.75V4.8h-2.75v38.4ZM347.019 11.483l-10.514 10.514-1.954-1.952 12.468-12.482v3.92Zm-8.548 12.489 8.548-8.505v17.067l-8.548-8.562ZM345.895 4.8l-13.286 13.3-8.339-8.337h-3.95l29.448 29.408V4.81l.01-.01h-3.883ZM326.694 24.013l-3.567 3.569v-7.163l3.581 3.58-.014.014Zm3.934 3.86-7.501 7.503V31.47l5.55-5.547 1.951 1.95ZM320.377 38.24h.001l-.001.001h3.825l8.396-8.396L345.959 43.2h3.881l-29.463-29.48v24.52ZM314.877 38.24h2.75V9.763h-2.75V38.24ZM623.04 36.828l-.271.016a144.214 144.214 0 0 1-.113-1.426c.154 2.22.226 3.256-.149 7.782l-.27-.016c-7.324-.436-18.02-1.074-15.884-32.028h10.284c.165 3.031.11 5.878.061 8.452-.149 7.732-.251 12.999 5.809 13.396.028.55.057 1.03.085 1.462-.165-2.621-.094-3.638.028-5.404.045-.66.098-1.423.149-2.413 6.06-.398 5.958-5.665 5.809-13.397-.049-2.573-.104-5.42.061-8.451h10.284c2.136 30.954-8.56 31.59-15.883 32.027Z"
                clipRule="evenodd"
              />
              <path
                fill="currentColor"
                d="M670.405 3.546h3.162v11.403c0 1.25-.295 2.35-.886 3.298-.585.95-1.409 1.69-2.472 2.225-1.062.528-2.304.792-3.724.792-1.426 0-2.67-.264-3.733-.792-1.062-.534-1.886-1.276-2.472-2.225-.585-.948-.877-2.048-.877-3.298V3.546h3.162v11.139c0 .727.159 1.375.477 1.943a3.472 3.472 0 0 0 1.363 1.338c.586.318 1.279.477 2.08.477.801 0 1.494-.159 2.079-.477a3.397 3.397 0 0 0 1.364-1.338c.318-.568.477-1.216.477-1.943V3.545Zm9.068 9.784V21h-3.085V7.91h2.949v2.224h.153a3.74 3.74 0 0 1 1.44-1.747c.665-.432 1.486-.648 2.463-.648.904 0 1.691.193 2.361.58a3.902 3.902 0 0 1 1.568 1.678c.375.733.56 1.623.554 2.668V21h-3.085v-7.858c0-.875-.227-1.56-.682-2.054-.449-.494-1.071-.741-1.866-.741-.54 0-1.02.12-1.441.358a2.49 2.49 0 0 0-.98 1.014c-.233.443-.349.98-.349 1.61Zm16.77 7.926c-1.307 0-2.429-.287-3.367-.86a5.755 5.755 0 0 1-2.156-2.379c-.5-1.017-.75-2.187-.75-3.511 0-1.33.256-2.503.767-3.52.512-1.023 1.233-1.818 2.165-2.386.937-.574 2.045-.861 3.324-.861 1.062 0 2.003.196 2.821.588.824.386 1.48.935 1.969 1.645.488.704.767 1.528.835 2.472h-2.949a2.816 2.816 0 0 0-.852-1.577c-.444-.426-1.037-.64-1.782-.64-.63 0-1.184.171-1.662.512-.477.335-.849.818-1.116 1.449-.261.63-.392 1.386-.392 2.267 0 .892.131 1.659.392 2.3.261.637.628 1.129 1.099 1.475.478.341 1.037.512 1.679.512.455 0 .861-.085 1.219-.256.364-.176.668-.429.912-.759.244-.329.412-.73.503-1.201h2.949c-.074.926-.347 1.747-.818 2.463-.472.71-1.114 1.267-1.927 1.67-.812.398-1.767.597-2.863.597Zm13.371 0c-1.278 0-2.386-.281-3.324-.844-.937-.562-1.664-1.35-2.181-2.36-.512-1.012-.767-2.194-.767-3.546 0-1.352.255-2.537.767-3.554.517-1.017 1.244-1.807 2.181-2.37.938-.562 2.046-.843 3.324-.843 1.279 0 2.387.281 3.324.844.938.562 1.662 1.352 2.173 2.369.518 1.017.776 2.202.776 3.554 0 1.352-.258 2.534-.776 3.545-.511 1.012-1.235 1.799-2.173 2.361-.937.563-2.045.844-3.324.844Zm.017-2.472c.694 0 1.273-.19 1.739-.57.466-.387.813-.904 1.04-1.552.233-.647.349-1.37.349-2.165 0-.8-.116-1.525-.349-2.173-.227-.653-.574-1.173-1.04-1.56-.466-.386-1.045-.579-1.739-.579-.71 0-1.301.193-1.772.58-.466.386-.816.906-1.049 1.56-.227.647-.341 1.371-.341 2.172 0 .796.114 1.518.341 2.165.233.648.583 1.165 1.049 1.551.471.381 1.062.571 1.772.571ZM718.026 21V7.91h2.991v2.181h.136c.239-.755.648-1.338 1.228-1.747a3.378 3.378 0 0 1 2.003-.622c.17 0 .36.008.571.025.215.012.394.032.537.06v2.838a3.26 3.26 0 0 0-.623-.12 5.711 5.711 0 0 0-.809-.059 3.12 3.12 0 0 0-1.517.367 2.68 2.68 0 0 0-1.049.997c-.255.426-.383.917-.383 1.474V21h-3.085Zm9.035 0V7.91h2.992v2.181h.136c.239-.755.648-1.338 1.227-1.747a3.38 3.38 0 0 1 2.003-.622c.171 0 .361.008.571.025.216.012.395.032.537.06v2.838a3.246 3.246 0 0 0-.622-.12 5.714 5.714 0 0 0-.81-.059c-.562 0-1.068.122-1.517.367a2.684 2.684 0 0 0-1.048.997c-.256.426-.384.917-.384 1.474V21h-3.085Zm14.292.256c-1.312 0-2.446-.273-3.4-.818a5.545 5.545 0 0 1-2.191-2.335c-.511-1.012-.767-2.202-.767-3.572 0-1.346.256-2.528.767-3.545.517-1.023 1.239-1.818 2.165-2.386.926-.574 2.014-.861 3.264-.861.807 0 1.568.13 2.284.392a5.158 5.158 0 0 1 1.909 1.193c.557.54.995 1.227 1.313 2.063.318.83.477 1.818.477 2.966v.946h-10.73v-2.08h7.773c-.006-.59-.134-1.116-.384-1.577a2.787 2.787 0 0 0-1.048-1.1c-.443-.266-.96-.4-1.551-.4-.631 0-1.185.154-1.662.46-.477.302-.85.7-1.117 1.194a3.442 3.442 0 0 0-.4 1.61v1.816c0 .761.139 1.415.417 1.96.279.54.668.955 1.168 1.244.5.285 1.085.427 1.756.427.449 0 .855-.063 1.219-.188a2.72 2.72 0 0 0 .946-.571c.267-.25.468-.56.605-.929l2.88.324a4.495 4.495 0 0 1-1.039 1.994c-.506.563-1.154 1-1.944 1.313-.789.306-1.693.46-2.71.46Zm11.036-17.71V21h-3.085V3.546h3.085Zm6.46 17.718c-.829 0-1.577-.147-2.241-.443a3.659 3.659 0 0 1-1.569-1.33c-.38-.584-.571-1.306-.571-2.164 0-.739.137-1.35.409-1.832.273-.483.645-.87 1.117-1.16a5.635 5.635 0 0 1 1.594-.656 12.953 12.953 0 0 1 1.849-.332c.767-.08 1.389-.15 1.867-.213.477-.068.823-.17 1.039-.307.222-.142.333-.36.333-.656v-.051c0-.642-.191-1.14-.571-1.492-.381-.352-.929-.528-1.645-.528-.756 0-1.355.165-1.798.494-.438.33-.733.719-.887 1.168l-2.88-.41c.227-.795.602-1.46 1.125-1.994a4.884 4.884 0 0 1 1.917-1.21c.756-.273 1.591-.409 2.506-.409.63 0 1.258.074 1.883.222a5.298 5.298 0 0 1 1.713.732c.517.336.932.793 1.245 1.373.318.58.477 1.304.477 2.173V21h-2.966v-1.798h-.102a3.777 3.777 0 0 1-.793 1.023c-.335.312-.758.565-1.27.758-.505.188-1.099.281-1.781.281Zm.801-2.267c.619 0 1.156-.122 1.611-.366.455-.25.804-.58 1.048-.989.25-.409.375-.855.375-1.338v-1.542c-.096.08-.261.153-.494.221a6.973 6.973 0 0 1-.767.18c-.284.05-.565.096-.844.136l-.724.102a5.38 5.38 0 0 0-1.236.307 2.05 2.05 0 0 0-.861.596c-.21.25-.315.574-.315.972 0 .568.207.997.622 1.287.415.29.943.434 1.585.434ZM774.92 7.91v2.387h-7.525V7.909h7.525Zm-5.667-3.136h3.085v12.29c0 .415.062.733.187.954.131.216.301.364.512.444.21.079.443.119.698.119.194 0 .37-.014.529-.043.165-.028.29-.054.375-.076l.52 2.411c-.165.057-.401.12-.708.188a5.78 5.78 0 0 1-1.108.12c-.772.022-1.468-.095-2.088-.35a3.251 3.251 0 0 1-1.474-1.21c-.358-.546-.534-1.228-.528-2.046V4.773Zm13.422 16.483c-1.312 0-2.446-.273-3.4-.818a5.545 5.545 0 0 1-2.191-2.335c-.511-1.012-.767-2.202-.767-3.572 0-1.346.256-2.528.767-3.545.517-1.023 1.239-1.818 2.165-2.386.926-.574 2.014-.861 3.264-.861.807 0 1.568.13 2.284.392a5.158 5.158 0 0 1 1.909 1.193c.557.54.995 1.227 1.313 2.063.318.83.477 1.818.477 2.966v.946h-10.73v-2.08h7.773c-.006-.59-.134-1.116-.384-1.577a2.787 2.787 0 0 0-1.048-1.1c-.443-.266-.96-.4-1.551-.4-.631 0-1.185.154-1.662.46-.477.302-.85.7-1.117 1.194a3.442 3.442 0 0 0-.4 1.61v1.816c0 .761.139 1.415.417 1.96.279.54.668.955 1.168 1.244.5.285 1.085.427 1.756.427.449 0 .855-.063 1.218-.188.364-.13.679-.321.947-.571.267-.25.468-.56.605-.929l2.88.324a4.495 4.495 0 0 1-1.039 1.994c-.506.563-1.154 1-1.944 1.313-.789.306-1.693.46-2.71.46Zm12.809-.026c-1.028 0-1.949-.264-2.761-.792-.813-.529-1.455-1.296-1.926-2.301-.472-1.006-.708-2.228-.708-3.665 0-1.455.239-2.682.716-3.682.483-1.006 1.134-1.764 1.952-2.275a5.015 5.015 0 0 1 2.736-.776c.767 0 1.397.13 1.892.392.494.256.886.565 1.176.929.29.358.514.696.673 1.014h.128V3.546h3.094V21h-3.034v-2.062h-.188a5.275 5.275 0 0 1-.69 1.014c-.301.352-.699.653-1.193.903-.495.25-1.117.375-1.867.375Zm.861-2.53c.653 0 1.21-.177 1.67-.53.461-.357.81-.854 1.049-1.49.238-.637.358-1.379.358-2.225 0-.847-.12-1.583-.358-2.208-.233-.624-.58-1.11-1.04-1.457-.455-.346-1.014-.52-1.679-.52-.688 0-1.261.18-1.722.537-.46.358-.806.852-1.039 1.483-.233.63-.35 1.352-.35 2.165 0 .818.117 1.548.35 2.19.238.637.588 1.14 1.048 1.509.466.363 1.037.545 1.713.545Zm-134.607 8.846 4.542 13.738h.179l4.534-13.738h3.478L668.317 45h-3.903l-6.145-17.454h3.469Zm18.805 17.71c-1.313 0-2.446-.273-3.401-.818a5.537 5.537 0 0 1-2.19-2.336c-.512-1.01-.767-2.201-.767-3.57 0-1.347.255-2.529.767-3.546.517-1.023 1.238-1.818 2.164-2.386.927-.574 2.015-.861 3.265-.861.806 0 1.568.13 2.284.392a5.166 5.166 0 0 1 1.909 1.193c.557.54.994 1.227 1.312 2.063.318.83.478 1.818.478 2.966v.946h-10.731v-2.08h7.773c-.006-.59-.133-1.116-.383-1.577a2.79 2.79 0 0 0-1.049-1.1c-.443-.266-.96-.4-1.551-.4-.63 0-1.184.154-1.662.46a3.171 3.171 0 0 0-1.116 1.194 3.43 3.43 0 0 0-.401 1.61v1.816c0 .761.139 1.415.418 1.96.278.54.667.955 1.167 1.244.5.285 1.086.426 1.756.426.449 0 .855-.062 1.219-.187a2.7 2.7 0 0 0 .946-.571c.267-.25.469-.56.605-.929l2.881.324a4.497 4.497 0 0 1-1.04 1.994c-.506.563-1.153 1-1.943 1.313-.79.306-1.693.46-2.71.46Zm11.036-7.926V45h-3.085V31.91h2.948v2.224h.154a3.74 3.74 0 0 1 1.44-1.747c.665-.432 1.486-.648 2.463-.648.904 0 1.691.193 2.361.58a3.902 3.902 0 0 1 1.568 1.678c.375.733.56 1.623.554 2.668V45h-3.085v-7.858c0-.875-.227-1.56-.682-2.054-.449-.494-1.071-.741-1.866-.741-.54 0-1.02.12-1.441.358a2.49 2.49 0 0 0-.98 1.014c-.233.443-.349.98-.349 1.61Zm17.596-5.42v2.386h-7.525v-2.387h7.525Zm-5.667-3.137h3.085v12.29c0 .414.063.733.188.954.13.216.301.364.511.444.21.079.443.119.699.119.193 0 .369-.014.528-.043.165-.028.29-.054.375-.076l.52 2.411c-.165.057-.401.12-.707.188a5.79 5.79 0 0 1-1.108.12c-.773.022-1.469-.094-2.088-.35a3.248 3.248 0 0 1-1.475-1.21c-.358-.546-.534-1.228-.528-2.046v-12.8Zm16.111 10.722v-7.586h3.086V45h-2.992v-2.326h-.136a3.936 3.936 0 0 1-1.458 1.798c-.67.466-1.497.699-2.48.699-.858 0-1.616-.19-2.275-.571-.654-.387-1.165-.946-1.534-1.68-.37-.738-.554-1.63-.554-2.675v-8.336h3.085v7.858c0 .83.227 1.489.682 1.978.454.488 1.051.733 1.789.733.455 0 .895-.111 1.321-.333a2.684 2.684 0 0 0 1.049-.989c.278-.443.417-.997.417-1.661ZM725.397 45V31.91h2.992v2.181h.136c.239-.755.648-1.338 1.227-1.747a3.378 3.378 0 0 1 2.003-.622c.171 0 .361.008.571.025.216.012.395.032.537.06v2.838a3.246 3.246 0 0 0-.622-.12 5.725 5.725 0 0 0-.81-.059c-.562 0-1.068.122-1.517.367a2.684 2.684 0 0 0-1.048.997c-.256.426-.384.917-.384 1.474V45h-3.085Zm14.292.256c-1.312 0-2.446-.273-3.4-.818a5.545 5.545 0 0 1-2.191-2.336c-.511-1.01-.767-2.201-.767-3.57 0-1.347.256-2.529.767-3.546.517-1.023 1.239-1.818 2.165-2.386.926-.574 2.014-.861 3.264-.861.807 0 1.568.13 2.284.392a5.157 5.157 0 0 1 1.909 1.193c.557.54.995 1.227 1.313 2.063.318.83.477 1.818.477 2.966v.946h-10.73v-2.08h7.773c-.006-.59-.134-1.116-.384-1.577a2.787 2.787 0 0 0-1.048-1.1c-.443-.266-.96-.4-1.551-.4-.631 0-1.185.154-1.662.46-.477.302-.85.7-1.117 1.194a3.442 3.442 0 0 0-.4 1.61v1.816c0 .761.139 1.415.417 1.96.279.54.668.955 1.168 1.244.5.285 1.085.426 1.756.426.449 0 .855-.062 1.218-.187a2.7 2.7 0 0 0 .946-.571c.268-.25.469-.56.606-.929l2.88.324a4.487 4.487 0 0 1-1.04 1.994c-.505.563-1.153 1-1.943 1.313-.789.306-1.693.46-2.71.46Zm18.298-9.886-2.813.306a2.263 2.263 0 0 0-.417-.8 2.084 2.084 0 0 0-.784-.606c-.33-.153-.733-.23-1.211-.23-.642 0-1.182.14-1.619.418-.432.278-.645.639-.639 1.082-.006.38.133.69.417.929.29.239.767.435 1.432.588l2.233.477c1.239.267 2.159.69 2.762 1.27.607.58.914 1.338.92 2.276-.006.824-.247 1.55-.724 2.182-.472.625-1.128 1.113-1.969 1.465-.841.353-1.807.529-2.898.529-1.602 0-2.892-.335-3.869-1.006-.977-.676-1.56-1.616-1.747-2.82l3.008-.29c.137.59.426 1.036.869 1.337.444.302 1.02.452 1.731.452.733 0 1.321-.15 1.764-.452.449-.3.673-.673.673-1.116 0-.375-.145-.685-.435-.929-.284-.244-.727-.432-1.329-.562l-2.233-.47c-1.256-.26-2.185-.7-2.787-1.32-.602-.625-.901-1.415-.895-2.37-.006-.806.213-1.505.656-2.096.449-.597 1.071-1.057 1.867-1.38.801-.33 1.724-.495 2.77-.495 1.534 0 2.741.327 3.622.98.886.654 1.434 1.537 1.645 2.65Z"
              />
            </svg>
          </Box>
        </Box>
      </Box>
      <Divider
        lineBg="linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(220, 220, 220, 1) 50%, rgba(255, 255, 255, 0) 100%)"
        lineBgDark="linear-gradient(270deg, #090909 0%, #E5E5E53D 50.39%, #090909 100%)"
        bg="linear-gradient(250deg, rgba(177, 255, 218, 0) 10%, rgba(221, 221, 221, 0.25) 50%, rgba(177, 255, 218, 0) 90%)"
        bgDark="linear-gradient(180deg, #E5E5E505 0%, #E5E5E510 1%)"
      />
      <Box as="section" css={{ container: 'xl', py: '$32' }}>
        <Box textCenter>
          <Text
            as="h2"
            size={{ '@initial': '2xl', '@md': '4xl' }}
            weight="bold"
          >
            Individual Investors
          </Text>
        </Box>
        <Box>
          <Box
            flex
            items="start"
            justify="center"
            css={{
              mt: '$20',
              gap: '$8',
              flexWrap: 'wrap'
            }}
          >
            {investors.map((person, index) => (
              <Investor key={index} {...person} />
            ))}
          </Box>
        </Box>
      </Box>
    </LayoutWebsite>
  )
}

export default AboutPage
